import { graphql, useStaticQuery } from 'gatsby';
import { PolicyProps } from './policyQuery';

const termsAndConditionsQuery = () => {
  const data = useStaticQuery(graphql`
    query TermsAndConditionsQuery {
        terms: mdx(frontmatter: {page: {eq: "terms"}}) {
            id
            body
            excerpt
            tableOfContents
            frontmatter {
                title
                date(formatString: "MMMM DD, YYYY")
                page
                authors
                description
                category
                tags
                published
            }
            internal {
                contentFilePath
            }
        }
    }
`);

  const terms: PolicyProps = data.terms;
  return { terms };
};


export { termsAndConditionsQuery };